import Link from '@/components/Link';
import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import { getBaseUrl } from '@gik/core/utils/LinkUtils';
import { Button, SvgIcon } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface ISeeFullWishlistButtonProps {
  inkindPage: InkindPageAPIModel;
}

export default function SeeFullWishlistButton({ inkindPage }: ISeeFullWishlistButtonProps) {
  const { t } = useTranslation();

  return (
    <Link href={`${getBaseUrl()}inkinds/${inkindPage.slug}/wishlist`}>
      <Button block prepend={<SvgIcon set="gik-icons" name="Wishlist" />}>
        {t(translationKeys.seeFull)}
      </Button>
    </Link>
  );
}
